import React from 'react'
import { connect } from 'react-redux'
import { getYearsEnrolled, isBlockedStudentConfiguration, isEligibleToEnrolNow, isEligibleToAcceptOffer, hasSanctions } from '../../helpers/enrolment'
import Loading from './Loading'
import { NavLink } from 'react-router-dom'
import { getProperty } from '../../helpers/properties'
import { getConfiguration } from '../../helpers/configuration'
import { fetchPersonalDataIfNeeded } from '../../actions/personalDetails'
import { setPageToDisplay } from '../../actions/enrolmentContainer'

const mapStateToProps = ({ courses: { data }, course: { selectedCourseCode, selectedCourse }, units, personalDetails, currentUser }) => {
  return {
    courseId: selectedCourseCode,
    courseAttemptStatus: selectedCourse.courseAttemptStatus,
    course: selectedCourse,
    sectorCode: selectedCourse.sectorCode,
    loadingPersonalDetails: personalDetails.isFetchingPersonalDetails,
    personalDetails: personalDetails.data,
    units: units[selectedCourseCode].items,
    userRole: currentUser.data['role'],
    loadingUnits: units[selectedCourseCode].receivedAt === null || units[selectedCourseCode].isFetching,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchPersonalDetails: () => {
      dispatch(fetchPersonalDataIfNeeded())
    },
    setPageToDisplay: (year) => {
      dispatch(setPageToDisplay(year))
    }
  }
}

class EnrolmentsTabs extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: true
    }
  }

  componentDidMount() {
    this.setState({
      loading: true
    })
    if (this.props.userRole == 'STUDENT') {
      this.props.fetchPersonalDetails()

      // if (!this.props.loadingUnits) {
      //   let units = this.props.units

      //   this.props.setPageToDisplay(units.length > 0 ? getYearsEnrolled(units)[0] : "NOW")
      // }
    }
    this.setState({
      loading: false
    })
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.userRole == 'STUDENT') {
      if (prevProps.courseId !== this.props.courseId) {
        this.state = {
          loading: true
        }
      }
      // else if (this.state.loading && !this.props.loadingUnits) {
      //   this.state = {
      //     loading: false
      //   }

      //   let units = this.props.units

      //   this.props.setPageToDisplay(units.length > 0 ? getYearsEnrolled(units[selectedCourseCode])[0] : "NOW")
      // }
    }
  }

  getEnrolButton = textToDisplay => {
    return (
      <li>
        <button className="span-button tab" onClick={() => this.setPageToDisplay("NOW")}><span className="tab-txt">{textToDisplay}</span></button>
        {/* <NavLink className="tab tab-enrol" to={getConfiguration('baseUrl') + '/enrolments/new'}>
          <span className="tab-txt">{textToDisplay}</span>
        </NavLink> */}
      </li>
    )
  }

  setPageToDisplay = (pageToDisplay) => {
    this.props.setPageToDisplay(pageToDisplay)
  }

  render() {
    if (this.props.userRole != 'STUDENT' || this.props.loadingPersonalDetails || this.state.loading || this.props.loadingUnits) {
      return null
    }

    return (
      <div>
        <div className="subnav">
          <ul className="tab-container">
            {isEligibleToEnrolNow(this.props.course, hasSanctions(this.props.personalDetails, this.props.courseId)) ? this.getEnrolButton('Enrol Now') : null}
            {getYearsEnrolled(this.props.units).map(year => {
              return (
                <li key={year}>
                  <button className="span-button tab" onClick={() => this.setPageToDisplay(year)}><span className="tab-txt">{year}</span></button>
                  {/* <NavLink className="tab" to={`${getConfiguration('baseUrl')}/enrolments/${year}`}>
                    <span className="tab-txt">{year}</span>
                  </NavLink> */}
                </li>
              )
            })}
          </ul>
        </div>
      </div>
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EnrolmentsTabs)
